import { onUserChange, User } from '@hub/shared'
import { InfluencerTransaction } from '@hub/shared/interfaces/payment.interface'
import { useEffect, useRef, useState } from 'react'
import { SubscriptionLike } from 'rxjs'

export interface AmountReceivableProps {
  transactionObject: InfluencerTransaction | null
  onChange?: (value: boolean) => any
  updateTransaction?: () => any
}

interface AmountReceivableState {
  loading: boolean
  user: User | null
}

interface AmountReceivableHookResponse {
  state: AmountReceivableState
  setState: (state: AmountReceivableState | any) => void
}

export type AmountReceivableGlobal = AmountReceivableProps & AmountReceivableHookResponse

const useAmountReceivable = (): AmountReceivableHookResponse => {
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [state, setState] = useState<AmountReceivableState>({
    loading: false,
    user: null,
  })

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe((userChanged: User) => {
      setState((prevState) => ({ ...prevState, loading: false, user: userChanged }))
    })

    return () => onUserChangeSubscription?.current?.unsubscribe()
  }, [])

  return { state, setState }
}

export default useAmountReceivable
